import { createAsyncThunk } from '@reduxjs/toolkit';
import { getServiceNowDataContactId } from 'services/pod';
import { IPodData } from 'services/pod/types';
import { convertSimplifiedToPodData } from '../helpers';

interface IProps {
  psaId: number;
  contactId: string;
}

export const ThunkGetServiceNowDataByContactId = createAsyncThunk<IPodData, IProps>(
  'pod/getServiceNowDataByContactId',
  async ({ psaId, contactId }) =>
    await getServiceNowDataContactId(psaId, contactId).then(r => r.data)
          .then(data => convertSimplifiedToPodData(data))
  ,
);
